// ##### 23-09-14 Komarov
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
// ##### 23-09-14 Komarov
// import './ConfirmButton.css'

// ##### Komarov 2025-08-05
const ConfirmButton = ({ clicked, available_now }) => {
  const ToCart = useLocalizedText('ToCart');
  const Cart = useLocalizedText('Cart');
  const SendRequest = useLocalizedText('SendRequest');
  const RequestSent = useLocalizedText('RequestSent');

  const getButtonText = () => {
    if (available_now) {
      return clicked ? Cart : ToCart;
    }
    return clicked ? RequestSent : SendRequest;
  };

  return (
    <button
      data-component="ConfirmButton"
      type="submit"
      // ##### Komarov 2025-07-02
      className={clicked ? 'NonActiveSubmit' : 'SubmitButton'}
    >
      {
        // ##### 24-04-24 Komarov
        // Confirm_Details
        getButtonText()
      }
    </button>
  );
};

export default ConfirmButton;
